'use strict';
import 'core-js/client/shim';
let bootstrapApp = require('bootstrap_app');
import 'reflect-metadata';
import 'angular';
import 'angular-load';

import {bundle} from 'ng-metadata/core';

import {PrimoExploreModule} from './primoExplore/primoExploreModule';


var angular:angular.IAngularStatic =  require('angular');
bootstrapApp.bootstrapConfiguration().then((res) => {
        if(window.location.search.indexOf('noCustomization=true')>-1) {
            return angular.bootstrap( document.querySelector('primo-explore'), [bundle(PrimoExploreModule).name] )
        }


        let deps = [];
        let centralModule, viewModule;
        if(res[0]) {
            try {
                centralModule = angular.module('centralCustom');
            } catch(err) {
            }
        }
        if(centralModule) {
            deps.push('centralCustom')
        }

        if(res[1]) {
            try {
                viewModule = angular.module('viewCustom');
            } catch(err) {
            }
        }

        if(viewModule) {
            deps.push('viewCustom');
        }

        return angular.bootstrap( document.querySelector('primo-explore'), [bundle(PrimoExploreModule, deps).name] );


    }
);







// WEBPACK FOOTER //
// ./src/main/webapp/components/app.ts